import { useState, useEffect } from 'react';
import { seekerIntakeService } from '../../../services/seekerIntakeService';
import { supabase } from '../../../lib/supabase';

export const useIntakeForm = () => {
  const [formData, setFormData] = useState({
    preferredName: '',
    ageRange: '',
    gender: '',
    populationSegment: '',
    languages: [],
    culturalBackground: '',
    religion: '',
    preferSameCulture: false,
    openToAnyCulture: false,
    currentIssues: [],
    symptoms: [],
    duration: '',
    additionalContext: '',
    hasExistingConditions: false,
    currentlyInTreatment: false,
    urgencyLevel: '',
    impactLevel: '',
    selfHarmThoughts: false,
    harmToOthers: false,
    expandSearchRadius: false,
    helperType: '',
    preferredLocation: '',
    sessionFormats: [],
    preferSameGender: false,
    openToAnyGender: false,
    requireExpertise: false,
    dataConsent: {
      matching: false,
      analytics: false,
      research: false,
      communications: false
    },
    privacySettings: {
      anonymousDisplay: false,
      hideFromDirectory: false,
      requireApproval: false
    },
    agreeToTerms: false,
    understandLimitations: false,
    reflectivePromptsResponses: {},
    voiceDictationTranscript: '',
    contextMediaUrls: []
  });

  useEffect(() => {
    const loadExistingIntake = async () => {
      // Check if user is authenticated before loading intake
      const { data: { user } } = await supabase?.auth?.getUser();
      if (!user) {
        // User not authenticated, skip loading existing intake
        return;
      }

      const { data, error } = await seekerIntakeService?.getIntake();
      if (data && !error) {
        setFormData(data);
      }
    };
    loadExistingIntake();
  }, []);

  const handleFormChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  return { formData, handleFormChange };
};